import { render } from "./legal-links-menu.vue?vue&type=template&id=0531b750"
import script from "./legal-links-menu.vue?vue&type=script&lang=js"
export * from "./legal-links-menu.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__